"use strict";

var _regeneratorRuntime = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAudioData = void 0;

var is_remote_asset_1 = require("./is-remote-asset");

var p_limit_1 = require("./p-limit");

var metadataCache = {};
var limit = (0, p_limit_1.pLimit)(3);

var fetchWithCorsCatch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(src) {
    var response, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(src, {
              mode: 'cors',
              referrerPolicy: 'no-referrer-when-downgrade'
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            error = _context.t0;

            if (!( // Chrome
            error.message.includes('Failed to fetch') || // Safari
            error.message.includes('Load failed') || // Firefox
            error.message.includes('NetworkError when attempting to fetch resource'))) {
              _context.next = 12;
              break;
            }

            throw new TypeError("Failed to read from ".concat(src, ": ").concat(error.message, ". Does the resource support CORS?"));

          case 12:
            throw _context.t0;

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function fetchWithCorsCatch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fn = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(src) {
    var audioContext, response, arrayBuffer, wave, channelWaveforms, metadata;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!metadataCache[src]) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", metadataCache[src]);

          case 2:
            if (!(typeof document === 'undefined')) {
              _context2.next = 4;
              break;
            }

            throw new Error('getAudioData() is only available in the browser.');

          case 4:
            audioContext = new AudioContext();
            _context2.next = 7;
            return fetchWithCorsCatch(src);

          case 7:
            response = _context2.sent;
            _context2.next = 10;
            return response.arrayBuffer();

          case 10:
            arrayBuffer = _context2.sent;
            _context2.next = 13;
            return audioContext.decodeAudioData(arrayBuffer);

          case 13:
            wave = _context2.sent;
            channelWaveforms = new Array(wave.numberOfChannels).fill(true).map(function (_, channel) {
              return wave.getChannelData(channel);
            });
            metadata = {
              channelWaveforms: channelWaveforms,
              sampleRate: audioContext.sampleRate,
              durationInSeconds: wave.duration,
              numberOfChannels: wave.numberOfChannels,
              resultId: String(Math.random()),
              isRemote: (0, is_remote_asset_1.isRemoteAsset)(src)
            };
            metadataCache[src] = metadata;
            return _context2.abrupt("return", metadata);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fn(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getAudioData = function getAudioData(src) {
  return limit(fn, src);
};

exports.getAudioData = getAudioData;